import Vue from "vue";

const jobs = [
  {
    index: 0,
    name: "Windows C#/C++开发(1人)",
    addrs: "杭州",
    respon: "岗位要求：",
    infos: [
      {
        line: 0,
        detail: "1. 本科及以上学历，拥有3年以上工作经验；"
      },
      {
        line: 1,
        detail: "2. 根据公司产品发展方向，负责/参与新产品开发； "
      },
      {
        line: 2,
        detail: "3.负责Windows端开发；"
      }
    ],
    qualify: "岗位职责：",
    must: [
      {
        line: 0,
        detail: "1. 熟悉 C# 语言、 VS 开发工具，熟练掌握 .NET 、CEF 等技术与框架；"
      },
      {
        line: 1,
        detail: "2.熟悉 C/C++ 语言、 VS开发工具，熟练掌握 COM 、 STL 、 ATL/WTL 等技术；"
      },
      {
        line: 2,
        detail: "3.熟悉 Windows GUI 界面开发技术，熟练掌握 GDI 、 GDI+ 、 DirectUI 等界面编程，熟悉 Windows 消息机制； "
      },
      {
        line: 3,
        detail: "4.至少掌握 MFC 、 Duilib 、 ATL 、 WTL 界面框架的一种；/视频剪辑能力优先;"
      },
      {
        line: 4,
        detail: "5.具备扎实的数据结构、算法基础，具有良好的网络通信，多线程编程经验；"
      },
      {
        line: 5,
        detail: "6.有银行业务开发背景优先，有视频产品和IM产品开发经验优先；"
      }
    ]
  },
  {
    index: 1,
    name: "交互设计师(1人)",
    addrs: "杭州",
    respon: "岗位要求：",
    infos: [
      {
        line: 0,
        detail: "1. 本科及以上学历，拥有3年以上相关工作经验；工业设计、数字媒体、美术、视觉传达、平面设计、广告设计、计算机等相关专业；"
      },
      {
        line: 1,
        detail: "2. 有图像设计软件Axure、Sketch、Photoshop等软件基础； "
      },
      {
        line: 2,
        detail: "3.有良好的团队合作能力和沟通能力，乐于分享，具有良好的抗压能力；"
      },
      {
        line: 3,
        detail: "4.对移动互联网有着热忱，感觉敏锐，热爱技术；"
      }
    ],
    qualify: "岗位职责：",
    must: [
      {
        line: 0,
        detail: "1.参与手机银行，移动oa系统的App、Web的交互设计工作；"
      },
      {
        line: 1,
        detail: "2.了解产品需求，完成产品界面的原型设计；"
      },
      {
        line: 2,
        detail: "3.参与完善交互设计文档；"
      },
      {
        line: 3,
        detail: "4.与开发团队紧密合作，确保产品设计理念和细节的有效实现；"
      },
      {
        line: 4,
        detail: "5.参与最终的交互设计验收工作；"
      }
    ]
  },
  {
    index: 2,
    name: "产品经理(1人)",
    addrs: "杭州",
    respon: "岗位要求：",
    infos: [
      {
        line: 0,
        detail: "1. 本科及以上学历，拥有5年以上互联网资深产品工作经验，有经验者优先；"
      },
      {
        line: 1,
        detail: "2.具有丰富的互联网产品原型设计能力，完成流程图，概念图，原型图等设计；熟悉测试理论和测试方法，有很好的测试理念，良好的问题分析和沟通能力；"
      },
      {
        line: 2,
        detail: "3.有优秀的理解能力和表达能力，有良好的沟通协调能力和团队合作精神具备强烈的责任心和上进心，成功导向；"
      }
    ],
    qualify: "岗位职责：",
    must: [
      {
        line: 0,
        detail: "1.负责完成市场研究，需求分析和规划；"
      },
      {
        line: 1,
        detail: "2.负责产品原型设计工作和产品功能文档编写工作；"
      },
      {
        line: 2,
        detail: "3.负责与项目研发、设计、测试、运营等相关人员有效积极沟通高效优质推进项目；"
      },
      {
        line: 3,
        detail: "4.关注行业动态，负责收集竞争产品动态与行业资讯，制定和完成具有战略前瞻性的产品策略；"
      },
      {
        line: 4,
        detail: "5.根据日常数据运营和监控，持续优化提升平台交互的便捷性，提升用户体验，实现用户有效转化；"
      }
    ]
  },
  {
    index: 3,
    name: "前端开发工程师(3人)",
    addrs: "杭州",
    respon: "岗位要求：",
    infos: [
      {
        line: 0,
        detail: "1.大专及以上学历，拥有3年以上工作经验；"
      },
      {
        line: 1,
        detail: "2.能够熟练运用HTML、CSS、JavaScript、VUE全家桶构建高性能的Web应用程序；"
      },
      {
        line: 2,
        detail: "3.能够熟练运用至少一款主流的JS框架，具有良好的代码风格、接口设计与程序架构能力；"
      },
      {
        line: 3,
        detail: "3.对Web前端的性能优化、开发调试、漏洞处理等有深入理解及实践"
      },
      {
        line: 4,
        detail: "3.逻辑分析能力强，善于沟通，有良好的沟通能力和团队合作能力；"
      }
    ],
    qualify: "岗位职责：",
    must: [
      {
        line: 0,
        detail: "1.负责公司平台产品的WEB前端设计和开发；"
      },
      {
        line: 1,
        detail: "2.和后端工程师和客户端工程师配合，提供前端解决方案，调用数据接口的逻辑开发和调试；"
      },
      {
        line: 2,
        detail: "3.负责解决产品的WEB前端适配兼容等问题；"
      },
      {
        line: 3,
        detail: "4.负责WEB前端性能和代码优化；"
      },
      {
        line: 4,
        detail: "5.独立完成WEB模块的软件需求分析、规格设计、代码编写、单元测试等工作；"
      }
    ]
  },
  {
    index: 4,
    name: "高级Java开发工程师(3人)",
    addrs: "杭州",
    respon: "岗位要求：",
    infos: [
      {
        line: 0,
        detail: "1.本科及以上学历，拥有5年以上Java开发经验；"
      },
      {
        line: 1,
        detail: "2.精通Java开发，对微服务架构有深入了解，并熟练掌握相关技术；"
      },
      {
        line: 2,
        detail: "3.熟悉Spring,Spring boot，Spring Cloud、mybatis，jpa等开源框架；"
      },
      {
        line: 3,
        detail: "4.熟悉掌握一种或者多种关系型数据库，如Mysql,oracle,db2；"
      },
      {
        line: 4,
        detail: "5.熟练掌握nosql数据库一种或者多种，redis；"
      },
      {
        line: 5,
        detail: "6.熟悉消息中间件，rabbitMq,kafka；"
      },
      {
        line: 6,
        detail: "7.熟悉多线程，高并发，大数据等相关技术；"
      },
      {
        line: 7,
        detail: "8.最少熟悉一种前端开发框架、有架构设计经验者、有小程序、App相关开发经验者优先；"
      }
    ],
    qualify: "岗位职责：",
    must: [
      {
        line: 0,
        detail: "1.根据公司产品发展方向，负责/参与新产品开发；"
      },
      {
        line: 1,
        detail: "2.负责移动产品的后台开发；"
      },
      {
        line: 2,
        detail: "3.协同其他技术部门，做前端开发技术支持； "
      }
    ]
  },
];

Vue.prototype.$const = {
  jobs
};
